import React, { useState } from 'react';
import { StyleSheet, View, ScrollView, KeyboardAvoidingView } from 'react-native';
import { getSpacing, useAlert } from '@rahtab/ui';
import { Screen } from '@rahtab/stack-navigator';
import ProviderHeaderCard from '../Home/ProviderHeaderCard';
import LoadDetail from './LoadDetail';
import OrderValue from './OrderValue';
import { RouteProp } from '@react-navigation/core';
import { RootStackType } from '../../Router';
import useSubmitOrder from '../../hooks/useSubmitOrder';
import { withSeparator } from '@rahtab/system/lib/tools/string';
import useListing from 'hooks/useListing';
import moment from 'moment-jalaali';

const shortIntervalMessage =
  'خطا در ثبت سفارش : فاصله بین دو درخواست شما کمتر از حد مجاز می‌باشد. چند ثانیه بعد دوباره تلاش کنید.';

const SubmitOrders: React.VFC<SubmitOrdersProps> = ({ route }) => {
  const [amount, setAmount] = useState('');
  const [latestSubmitTime, setLatestSubmitTime] = useState(moment());
  const { listingId } = route?.params;
  const { data: listing, loading } = useListing(listingId);
  const alert = useAlert();
  const [submitOrder, { loading: isSubmiting }] = useSubmitOrder({
    measureCode: listing.unit,
    offerCode: listing.id,
    unitPrice: listing.price,
    requestAmount: amount,
  });

  const latestSubmitHappenedJustNow = (): boolean => {
    if (Math.abs(latestSubmitTime.diff(moment(), 'seconds')) < 6) return true;
    return false;
  };

  const alertTooShortIntervalBetweenSubmits = () => {
    alert({
      message: shortIntervalMessage,
      title: 'پیام سیستم',
      severity: 'error',
    });
  };

  const handleSubmit = () => {
    if (latestSubmitHappenedJustNow()) alertTooShortIntervalBetweenSubmits();
    else {
      submitOrder();
      setLatestSubmitTime(moment());
    }
  };

  return (
    <Screen
      title="ثبت سفارش"
      style={styles.mainStyle}
      loading={loading}
      transparentLoading={isSubmiting}
      data={{ ...listing }}
      renderMain={({
        seller,
        deliveryDate,
        price,
        viewerOrderLimit,
        unitText,
        ratingCount,
        merchandiseId,
        name: merchandiseName,
        termName,
      }) => {
        return (
          <ScrollView keyboardShouldPersistTaps={'handled'}>
            <KeyboardAvoidingView>
              <View style={styles.providerHeaderContainer}>
                <ProviderHeaderCard
                  name={seller.name}
                  image={seller.imageUrl}
                  id={seller.id}
                  rateCount={ratingCount}
                  city={seller.city}
                />
              </View>
              <LoadDetail
                productCode={merchandiseId}
                productName={merchandiseName}
                rate={0}
                date={deliveryDate}
                unitPrice={price}
                numberOfRates={ratingCount}
                loadOrderLimit={withSeparator(viewerOrderLimit)}
                measureUnit={unitText}
                termName={termName}
              />
              <OrderValue
                amount={amount}
                onAmountChange={setAmount}
                disabled={parseFloat(amount) === 0 || !amount}
                unitPrice={price}
                unit={unitText}
                onSubmitPress={handleSubmit}
              />
            </KeyboardAvoidingView>
          </ScrollView>
        );
      }}
    />
  );
};

export default SubmitOrders;

const styles = StyleSheet.create({
  providerHeaderContainer: {
    marginTop: getSpacing(),
  },
  mainStyle: {
    paddingHorizontal: getSpacing(),
  },
});

interface SubmitOrdersProps {
  route: RouteProp<RootStackType, 'SubmitOrders'>;
}
